import React, { Component } from 'react';
import Select from 'react-select';
import {getData} from '../store';
import {Course, Loading} from './helpers';
import {listAllRegions, listAllCourses, prepareArrayForSelect, removeDiacritics, dateToMonth} from './lib.js'
import scrollToElement from 'scroll-to-element';
import {eventSelected, citiesSelected, monthSelected} from '../statistics';
import {hashHistory} from 'react-router';
import '../styles/icono.scss';
import '../styles/plugin.scss';

/**
 * Main component
 *
 * @class Events
 * @extends {Component}
 */
class Events extends Component {

	constructor(props) {

		//Expose this.props in the constructor
		super(props)

		//Init the state
		this.state = {
			data : '', //all the courses
			displayData:'', //Courses that matches filter
			cities:'', //Cities list
			coursesNames:'', //Courses names list
			currentCouseValue:'', //Selected course
			currentCityValue:'' //Selected City
		};

		//Store the data in the state
		this.storeState = (data, cities, courseName)=> {
			//If we access the page with a link
			//example .../ville/Chicoutimi or /formation/Optimiser son temps...
			let displayData;

			if (this.props.params.ville) {
				let filter = this.props.params.ville.split(',');
				
				//Set selected value from url
				let currentCityValue = filter.map((ville) => { 
					return {"label":ville, "value": removeDiacritics(ville)}
				})
				
				this.setState({ currentCityValue: currentCityValue})

				displayData = data.filter((out)=>{
					return filter.indexOf(removeDiacritics(out.region)) > -1
				})
			}

			if (this.props.params.formation) {
				let filter = this.props.params.formation.split(',');

				//Set selected value from url
				let currentCouseValue = filter.map((formation) => { 
					return {"label":formation, "value": removeDiacritics(formation)}
				})
				
				this.setState({ currentCouseValue: currentCouseValue})

				displayData = data.filter((out)=>{
					return filter.indexOf(removeDiacritics(out.title)) > -1
				})
			}

			this.setState({
				data: data,
				displayData: (displayData && displayData.length > 0) ? displayData : data,
				cities: cities,
				coursesNames: courseName
			});
		};

		//Restore displayData to show all courses
		this.restoreDisplayData = ()=>{
			this.setState({
				displayData:this.state.data,
				currentCouseValue:'',
				currentCityValue:''
			})
		};

		/**
		 * Handle courses / formations
		 */
		this.OnChangeCourse = (selected)=>{
			let flatSelected = [];

			//[{label:'',value:''},{}]==>[label1, label2...]
			for (let i = 0; i < selected.length; i++) {
				flatSelected.push(removeDiacritics(selected[i].label))
			}

			//If you hit "X clear all" button
			if (!selected || selected.length === 0) {
				this.restoreDisplayData();
				this.restoreDeepLink();
				flatSelected = [];
				return;
			}

			//search for cities
			if (this.state.displayData !== '') {
				let newDisplayData = this.state.data.filter((data)=>{
					return flatSelected.indexOf(removeDiacritics(data.title)) > -1
				});

				this.setState({
					currentCouseValue: selected,
					currentCityValue:'',
					displayData : newDisplayData
				});

				//set deep link
				this.handleSelectedCourseDeepLink(flatSelected)
			}

			//statistics module
			eventSelected(selected)
		};

		/**
		 * Handle cities / regions
		 */
		this.OnChangeCity = (selected)=>{
			let flatSelected = [];

			//[{label:'',value:''},{}]==>[label1, label2...]
			for (let i = 0; i < selected.length; i++) {
				flatSelected.push(removeDiacritics(selected[i].label))
			}

			//If you hit "X clear all" button
			if (!selected || selected.length === 0) {
				this.restoreDisplayData();
				this.restoreDeepLink();
				flatSelected = [];
				return;
			}

			//search for cities
			if (this.state.displayData !== '') {
				let newDisplayData = this.state.data.filter((data)=>{
					return flatSelected.indexOf(removeDiacritics(data.region)) > -1
				})

				this.setState({
					currentCityValue: selected,
					currentCouseValue: '',
					displayData : newDisplayData
				});

				//set deep link
				this.handleSelectedCityDeepLink(flatSelected)
			}

			//statistics module
			citiesSelected(selected)
		}

		/**
		 * Handle months / jump to a month
		 */
		this.OnChangeMonth = (selected)=>{
			var elem = document.querySelector('.' + selected.value);
			scrollToElement(elem, {
				offset: - 100, /* negative: above elem, positive: after elem */
				duration: 1500
			});

			//statistics module
			monthSelected(selected)
		};

		/**
		 * Handle to top event
		 */
		this.toTop = ()=>{
			var elem = document.querySelector('.mp-plus-events-calendar');
			scrollToElement(elem, {
				offset: 0,
				duration: 1500
			});
		};

		/**
		 * handle deeplinking uri
		 *
		 */
		this.handleSelectedCityDeepLink = (e) => {
			hashHistory.push('/ville/' + e);
		}

		this.handleSelectedCourseDeepLink = (e) => {
			hashHistory.push('/formation/' + e);
		}

		this.restoreDeepLink = () => {
			hashHistory.push('/');
		}


	}

	/**
	 * Handle the Data
	 */
	//Wait until the page loads
	componentDidMount() {

		//Get data and store it in the state
		getData((err, d)=>{
			if (err) {
				throw new Error(err)
			} else {
				const cities = listAllRegions(d);
				const courseName = listAllCourses(d);
				this.storeState(d, cities, courseName);
			}
		})
	}


	/**
	 * Handle the Display
	 */
	render() {

		//Select default values (while loading)
		const DEFAULT_COURSE_SELECT = [{label:'Chargement des cours', value:''}];
		const DEFAULT_CITY_SELECT = [{label:'Chargement des régions', value:''}];
		const SELECT_MONTH = [
			{label:'Janvier', value:'January'},
			{label:'Février', value:'February'},
			{label:'Mars', value:'March'},
			{label:'Avril', value:'April'},
			{label:'Mai', value:'May'},
			{label:'Juin', value:'June'},
			{label:'Juillet', value:'July'},
			{label:'Août', value:'August'},
			{label:'Septembre', value:'September'},
			{label:'Octobre', value:'October'},
			{label:'Novembre', value:'November'},
			{label:'Décembre', value:'December'}

		];

		//Inject and id once controller
		let ejectedMonth = [];

		//All courses without filter
		const AllCourses = this.state.displayData ? this.state.displayData.map((course)=>{
			const dateObject = new Date(course.start);
			const month = dateToMonth(dateObject);
			let id = ejectedMonth.indexOf(month) === -1 ? month : Math.random();
			let out = <div key={Math.random() + course.id} id={id}>{Course(course)}</div>
			//push to ejected so we dont collide div ids
			ejectedMonth.push(month)

			return out;
		}) : Loading

		//Courses name list prepared for Select
		const AllCoursesNames = this.state.coursesNames ? prepareArrayForSelect(this.state.coursesNames) : DEFAULT_COURSE_SELECT

		//Cities name list prepared for Select
		const AllCitiesNames = this.state.cities ? prepareArrayForSelect(this.state.cities) : DEFAULT_CITY_SELECT;

		//Render page
		return (
			<div className="mp-plus-events-calendar">
			<div className="to-top"><a href='#' onClick={this.toTop}><i className='icono-caretUp big-icon'></i></a></div>
				<div className='mp-wrapper'>
				<div className='plugin-header'>
					<ul>
						<li>
							<Select
								name="all-courses-names"
								options={AllCoursesNames}
								value={this.state.currentCouseValue}
								onChange={this.OnChangeCourse}
								className='medium-div'
								placeholder="Choisissez une ou plusieurs formations"
								multi={true}
							/>
						</li>
						<li>
							<Select
								name="all-cities-names"
								options={AllCitiesNames}
								value={this.state.currentCityValue}
								onChange={this.OnChangeCity}
								className='small-div'
								placeholder="Choisissez ville(s)"
								multi={true}
							/>
						</li>
						<li>
							<Select
								name="all-months"
								options={SELECT_MONTH}
								onChange={this.OnChangeMonth}
								className='small-div'
								placeholder="Choisissez un mois"
							/>
						</li>
					</ul>
					</div>

					{AllCourses}

				</div>
			</div>
		);
	}
}

//Expose the component
export default Events



/** WEBPACK FOOTER **
 ** ./src/components/widget/index.js
 **/